import { ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { addError, removeError } from '@core/utils/error-functions';
import moment from 'moment';

export class DataRangeValidation {

  static validate(formGroup: FormGroup): any {
    const initialDate = formGroup.controls.from.value;
    const finalDate = formGroup.controls.until.value;

    const datesExist = Boolean(initialDate && finalDate);
    const isValidDates = moment(initialDate).isValid() && moment(finalDate).isValid();

    if (datesExist && isValidDates) {
      if (moment(initialDate).isSameOrAfter(finalDate)) {
        addError(formGroup.controls.from, 'dateRangeInvalid');
      } else {
        removeError(formGroup.controls.from, 'dateRangeInvalid');
      }
    }

    return null;
  }
}
